var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('profile-user-data'),_c('profile-customer-data',{attrs:{"customer":_vm.customer}}),_c('profile-domain-data',{attrs:{"customer":_vm.customer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }